import Api from "@/lib/axios";

const FeesService = {
  createFees (params) {
    return Api.post("/api/autopricing/fees/bulk", params, {
      tenant: true
    });
  },

  updateFees (params) {
    return Api.post("/api/autopricing/fees/bulk", params, {
      tenant: true
    });
  },

  deleteFees (params) {
    return Api.post("/api/autopricing/fees/bulk/delete", params, {
      tenant: true
    });
  },

  exportCsv(params) {
    return Api.get("/api/autopricing/fees/filtered.csv", {
      data: params,
      tenant: true
    });
  },
  async getFees(payload) {
    const data = {
      ...payload,
      page: (payload.page || 1) - 1
    };

    const response = await Api.get("/api/autopricing/fees", {
      data,
      tenant: true
    })

    const list = response?.data?.content || [];
    const pagination = response?.data?.pageable || {};

    return {
      list,
      pagination: {
        ...pagination,
        totalElements: response?.data?.totalElements,
        totalPages: response?.data?.totalPages
      }
    };
  },
  uploadFees(payload) {
    return Api.post("/api/autopricing/fees/bulk-upload", payload, {
      tenant: true
    });
  },
  async previewFees(payload) {
    const response = await Api.post("/api/autopricing/fees/bulk-upload/preview", payload, {
      tenant: true
    });
    return response?.data;
  }
}

export default FeesService;